var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 68,
    viewBox: "0 0 70 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 16.0002C38 14.8939 37.3906 13.8814 36.4156 13.3564C35.4406 12.8314 34.2594 12.8877 33.3312 13.5064L24.3312 19.5064C22.9531 20.4252 22.5875 22.2814 23.5063 23.6689C24.425 25.0564 26.2906 25.422 27.6687 24.5033L32 21.6064V49.0002H26C24.3406 49.0002 23 50.3408 23 52.0002C23 53.6595 24.3406 55.0002 26 55.0002H35H44C45.6594 55.0002 47 53.6595 47 52.0002C47 50.3408 45.6594 49.0002 44 49.0002H38V16.0002Z",
    fill: "#EE7733"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneIcon);
export default __webpack_public_path__ + "static/media/one-icon.9c5130ad6772b24f6d501a62905e99f4.svg";
export { ForwardRef as ReactComponent };